import { Navigate, useLocation } from 'react-router-dom';

/**
 * Story #25511 (BR-C-SRPT-001) — Case Metrics is renamed Service Reports. An old /case-metrics deep
 * link lands on the new page (history replace, query string and hash kept) rather than 404ing. Mounted at
 * the `case-metrics` route in App.tsx; lives beside the page so its test can render it directly.
 */
export default function CaseMetricsRedirect() {
  const location = useLocation();
  return <Navigate to={`/service-reports${location.search}${location.hash}`} replace />;
}
